import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'pay/web/login/login',
    method: 'post',
    data
  })
}
export function getInfo(token) {
  return request({
    url: 'pay/queryUserInfo/' + token,
    method: 'get'
  })
}

export function logout() {
  return request({
    url: 'pay/logout',
    method: 'post'
  })
}
